var exports = {
  "i": "x127c5a35--74755a--wrapper",
};

module.exports = exports;
